import { css } from '@emotion/css'
import { spacing, fontWeight, colors } from '@offerzen/pinata-shame'

const styles = {
  link: css({
    cursor: 'pointer',
    display: 'flex',
    padding: spacing.default,
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    color: colors.jumbo,
    transition: 'color 0.2s, background-color 0.2s',

    '&:hover': {
      backgroundColor: colors.hawkesBlue,
      color: colors.cornflowerBlue,
    },

    '&:focus': {
      outline: 'none',
      backgroundColor: colors.hawkesBlue,
      color: colors.cornflowerBlue,
    },
  }),

  linkActive: css({
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold,
    pointerEvents: 'none',
    cursor: 'default',
  }),
}

export default styles
